import { el } from "./dom";
import { venue } from "../content/site";

/** Always open Google Maps with the venue query, on every platform. */
export function mapsHref(): string {
  const query = encodeURIComponent(`${venue.name}, ${venue.address}`);
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

/** Small inline pin SVG, used inside the Padkaart button. */
export function mapPin(): HTMLElement {
  const span = el("span", { class: "padkaart__icon" });
  span.innerHTML =
    `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-7.5-7-12a7 7 0 0 1 14 0c0 4.5-7 12-7 12z"/><circle cx="12" cy="9" r="2.5"/></svg>`;
  return span;
}
